import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { Column } from '../interfaces/column.interface';

@Injectable({
  providedIn: 'root'
})
export class ResetModeServiceColumnsService {


  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
  ) {
  }
 
  getColumns(): Column[] {
    return [

      { field: 'name', sortField: 'name', title: this.translate.instant('CONTENT.NAME'), show: (this.navigation.getParamValue('applications.name.showFiled', true) && true), displayInList: true, type: 'textValue' },
     
      { field: 'isActive', sortField: 'isActive', title: this.translate.instant('CONTENT.SATUTS'), show: (this.navigation.getParamValue('applications.isActive.showFiled', false) && true), displayInList: true, type: 'colorValue'},
      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('created At'), show: (this.navigation.getParamValue('applications.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT') },
      { field: 'updatedAt', sortField: 'updatedAt', title: this.translate.instant('updated At'), show: (this.navigation.getParamValue('applications.updatedAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT') },

     
     
     
      { field: 'actions', title: this.translate.instant('CONTENT.ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null },
    ];
  }

}
